import { Container } from '@paypalcorp/pp-react'
import React, { useState, useEffect } from 'react'
import { config } from './config'
import { DropdownListItemLink } from '../DropdownListItemLink'
import './navigation-buttons.css'
import { traverseListWithKeyboard } from '../utils/keyboardNavigation'
import { useApplicationContext } from '../../../../provider'

interface NavigationButtonProps {
  navList: any
}

const NavigationButton: React.FC<NavigationButtonProps> = ({ navList }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [cursor, setCursor] = useState<any>(null)

  useEffect(() => {
    if (!isOpen) {
      setCursor(null)
    }
  }, [isOpen])

  return (
    <li
      className={`nav-item ${isOpen && 'nav-item__selected'}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
      onKeyDown={(e) => traverseListWithKeyboard(e, navList, setCursor)}
    >
      <div>
        <a
          className={`menu-link ${isOpen && 'menu-link__selected'}`}
          href={navList.link}
          tabIndex={0}
        >
          {navList.title}
        </a>
        <div
          className={`${isOpen && `dropdown-content__open`} dropdown-content`}
        >
          {navList.children &&
            navList.children.map((item: any, i: any) => (
              <DropdownListItemLink
                item={item}
                active={i === cursor}
                parent="navigationButton"
                key={i}
              />
            ))}
        </div>
      </div>
    </li>
  )
}

const NavigationButtons = () => {
  const { experiments } = useApplicationContext()
  let menus = config

  useEffect(() => {
    const treat1 = experiments.integrationBuilder || ''
    const treat2 = experiments.integrationBuilderKBYC || ''
    let isIntegrationBuilderTrmt =
      treat1.startsWith('Trmt_') || treat2.startsWith('Trmt_')
    menus = config.map((navList) => {
      // Add Integration Builder under Tools menu
      if (
        navList.title === 'Tools' &&
        navList.children?.[0].url !== '/integration-builder' &&
        isIntegrationBuilderTrmt
      ) {
        navList.children?.unshift({
          title: 'Integration Builder',
          url: '/integration-builder',
        })
      }
      return navList
    })
  }, [experiments])

  return (
    <Container className="nav-container">
      <ul className="header-list">
        {menus.map((menuItem) => (
          <NavigationButton navList={menuItem} key={menuItem.id} />
        ))}
      </ul>
    </Container>
  )
}

export default NavigationButtons
